var map = {
	"./advice.svg": "6ef9",
	"./change-personal-info.svg": "8e5a",
	"./change-phone.svg": "0146",
	"./enterprise-certification.svg": "65a2",
	"./real-name-authentication.svg": "2ff4",
	"./retrieve-password.svg": "35e5",
	"./service.svg": "4e04",
	"./shop-enter.svg": "d08e",
	"./tel.svg": "2315"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";